/**
 * Format a thrown value into something safe to render. Defensive — even if a
 * future queryFn throws a plain object, this can never render
 * `[object Object]`.
 */
export function formatError(err: unknown): string {
  if (err instanceof Error) return err.message
  if (typeof err === 'string') return err
  if (err == null) return 'Unknown error'
  try {
    return JSON.stringify(err)
  } catch {
    return 'Unknown error'
  }
}
